<mat-card data-at-installations-migration-error-modal>
  <mat-card-title data-at-installations-migration-modal-header>{{
    '+INSTALLATIONS_MIGRATION.HEADER_MIGRATION_FAILED' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col">
    <div data-at-installations-migration-modal-description class="migration__description">
      {{ '+INSTALLATIONS_MIGRATION.MIGRATION_ERROR' | translate }}
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button data-at-installations-migration-cancel mat-button color="primary" (click)="onClose()">
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-installations-migration-btn-retry
      (click)="onRetry()"
      mat-raised-button
      color="primary"
    >
      {{ '+INSTALLATIONS_MIGRATION.BTN.TRY_AGAIN' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
